export enum RoutesName {
  login = '/',
  terms = '/terms',
  home = '/home',
  transfers = '/transfers',
  transfersProgress = '/transfersProgress',
  transferSuccessful = '/transferSuccessful',
  transferError = '/transferError',
  transferDenied = '/transferDenied',
  successfulRegister = '/successfulRegister',
  deniedRegister = '/deniedRegister',
  widget = '/widget',
  noAuthorized = '/noAuthorized',
  notFound = '/404',
  selection = '/selection',
  voiceSelection = '/voiceSelection',
  configuration = '/configuration',
  userInfo = '/userInfo',
}

export enum AuthName {
  token = 'TOKEN',
  refreshToken = 'REFRESH_TOKEN',
}

export enum DeviceSize {
  mobile = 768,
  desktop = 1024,
}

export const imageFace = 'imageFace';
export const vocalTemplate = 'vocalTemplate';
export const userAvatar = 'userAvatar';

export const maxAmount = 15000;

export const endPoints = {
  Authenticate: {
    Antispoofing: '/api/authenticate/antispoof',
  },
  Start: '/workflows',
  Assets: {
    Register: '/assets/register',
    Authenticate: '/assets/authenticate',
    Selfie: '/selfie',
    Audio: '/audio'
  },
  Terms: '/tac',
  TermsAcceptance: '/tac/acceptance',
};

export const family = 'AUTHENTICATION';

export enum FacialProcess {
  autentication = 'AUTHENTICATION',
  register = 'REGISTER'
};

export const SELFIE = 'SELFIE';
export const VOICE = 'VOICE';
export const WEB_SOURCE = 'web';

export const STATUS_CODE_200 = 200;
export const STATUS_CODE_401 = 401;

export const REQUIRED_FIELD_MESSAGE = 'This field is required';
export const DEMOS_BE = 'demos-backend';